module.exports = __webpack_public_path__ + "resources/img/img_gamebase_game5.63b971aaad74cdb92c5c72fe067959ba.png";